module.exports = __webpack_public_path__ + "static/media/oven-state-4.578f9a24.wav";